import { render, staticRenderFns } from "./editorBox.vue?vue&type=template&id=0c85cb61&scoped=true&"
import script from "./editorBox.vue?vue&type=script&lang=js&"
export * from "./editorBox.vue?vue&type=script&lang=js&"
import style0 from "./editorBox.vue?vue&type=style&index=0&id=0c85cb61&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c85cb61",
  null
  
)

export default component.exports